<template>

<div class="dashboard">

	<div class="dashboard-intro">
		<p>There are a number of different ways to improve bone health.</p>
		<p>Please click the icons to see more information.</p>
	</div>

	<div class="dashboard-icons">

		<div class="dashboard-icons-item" :data-name="icon" v-for="icon in icons" :key="icon" v-on:click="$emit('click', icon)">

			<div class="dashboard-icons-item-text">{{ section[icon].title }}</div>

		</div>

	</div>

	<div class="dashboard-foot" v-if="!$isPatient">

		<com-check v-on:next="$emit('next')" :info="section.proceedInfo" :text="section.proceed" />

	</div>

</div>

</template>

<script>

import comCheck from './../common/Check'

export default {

	props: ['section'],

	components: {
		'com-check': comCheck
	},

	data: function() {

		return {
			icons: ['diet', 'treatment', 'supplements', 'stress', 'habits', 'activity']
		}

	}
	
}

</script>

<style scoped>

.dashboard-intro {
	color: #343434;
	font-size: 18px;
	line-height: 26px;
	font-weight: 300;
	margin-bottom: 32px;
}

.dashboard-intro p {
	margin-bottom: 8px;
}

.dashboard-intro p:last-child {
	margin-bottom: 0;
}

.dashboard-icons {
	display: flex;
	flex-wrap: wrap;
}

.dashboard-icons-item {
	border-radius: 17px;
	background-color: #f6f6f6;
	margin-bottom: 32px;
	width: calc(33.3% - 22px);
	height: 207px;
	background-repeat: no-repeat;
	background-position: 50% 16px;
	cursor: pointer;
}

.dashboard-icons-item:hover {
	background-color: #ddd;
}

.dashboard-icons-item:nth-child(2),
.dashboard-icons-item:nth-child(5) {
	margin: 0px 32px 32px 32px;
}

.dashboard-icons-item[data-name="diet"] { background-image: url(~@/assets/aid/improve/icon.diet.svg); }
.dashboard-icons-item[data-name="treatment"] { background-image: url(~@/assets/aid/improve/icon.treatment.svg); }
.dashboard-icons-item[data-name="supplements"] { background-image: url(~@/assets/aid/improve/icon.supplements.svg); }
.dashboard-icons-item[data-name="stress"] { background-image: url(~@/assets/aid/improve/icon.stress.svg); }
.dashboard-icons-item[data-name="habits"] { background-image: url(~@/assets/aid/improve/icon.habits.svg); }
.dashboard-icons-item[data-name="activity"] { background-image: url(~@/assets/aid/improve/icon.activity.svg); }

.dashboard-icons-item-text {
	position: absolute;
	left: 16px;
	right: 16px;
	top: 140px;
	text-align: center;
	color: #343434;
	font-weight: 600;
	font-size: 20px;
	line-height: 24px;
	padding: 0px 16px;
}

.dashboard-icons-item-tag {
	background-color: #F8A533;
	color: #343434;
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
	padding: 0px 10px;
	line-height: 20px;
	border-radius: 10px;
	position: absolute;
	left: 50%;
	bottom: 20px;
	white-space: nowrap;
	transform: translateX(-50%);
}

.dashboard-foot {
	display: flex;
	justify-content: flex-end;
}

</style>
